{
  "version": "7",
  "dialect": "sqlite",
  "entries": [
    {
      "idx": 0,
      "version": "6",
      "when": 1783878007968,
      "tag": "0000_baseline",
      "breakpoints": true
    }
  ]
}
